module.exports = __webpack_public_path__ + "static/media/eventImg.5a3dc780.png";